import Apiservice from '@/core/services/api.service';
import {API_URL} from '@/common/config.js'

const apiService = Apiservice;


export default class HomePageSectionService {

    #api = null;

    constructor() {
        this.#api = `${API_URL}user/homepage-section`;

    }

    paginate(data = null, index = null) {
        let url = `${this.#api}`;
        if (data != null && data != undefined && data != "") {
            var queryString = Object.keys(data).map((key) => {
                if (data[key] && data[key] != null)
                    return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
            }).join('&');
            url = url + '?' + queryString;

        }
        if (queryString) {
            url = url + '&' + "page=" + (index);
        } else
            url = url + '?' + "page=" + (index);
        return apiService.get(url);
    }

    allActive() {
        let url = `${this.#api}/active/all`
        return apiService.get(url);
    }

    update(id, data) {
        let url = `${this.#api}/${id}/update`
        return apiService.post(url, data);

    }

    store(data) {
        let url = `${this.#api}`
        return apiService.post(url, data);

    }

    show(id) {
        let url = `${this.#api}/${id}`
        return apiService.get(url);
    }

    sort(id, index) {
        let url = `${this.#api}/${id}/${index}/sort`;
        return apiService.get(url);
    }


    delete(id) {
        let url = `${this.#api}/${id}`
        return apiService.delete(url);
    }
}
